import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { config } from "./wagmi";
import App from "./App";
import { capturaReferidoDeLaUrl } from "./lib/referido";
import { IdiomaProvider } from "./lib/i18n";
import "./styles.css";

// ANTES DE PINTAR NADA. Quien llega por un enlace de invitacion casi nunca tiene la wallet
// conectada: si el `?ref=` se leyera al conectar, se perderia en la mayoria de las visitas. Se
// guarda aqui, en cuanto la pagina existe, y espera a que haya alguien a quien atribuirselo.
capturaReferidoDeLaUrl();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Los RPC publicos cortan en rafaga: mejor ritmo constante que ir a tope y comerse un 429.
      retry: 3,
      retryDelay: (intento) => Math.min(1000 * 2 ** intento, 8000),
      staleTime: 15_000,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <IdiomaProvider>
          <App />
        </IdiomaProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </StrictMode>
);
